module.exports = __webpack_public_path__ + "static/media/cardMarriage.d75f2865.png";